/* eslint-disable no-param-reassign */
export default {
  inserted(el) {
    if (process.env.VUE_APP_ENV === 'production') {
      el.style.display = 'none';
    }
  },
};
